import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  repo: z.string().min(1), // full_name e.g. "owner/repo"
  branch: z.string().optional(), // defaults to default_branch if omitted
});

export type InputType = z.infer<typeof schema>;

export type GithubFileNode = {
  path: string;
  sha: string;
  size: number;
};

export type OutputType = {
  files: GithubFileNode[];
  truncated: boolean;
  totalFiles: number; // Total number of blobs found in the tree before filtering
  filteredFiles: number; // Number of files returned after filtering
};

export const getGithubTree = async (input: InputType, init?: RequestInit): Promise<OutputType> => {
  const params = new URLSearchParams();
  params.set('repo', input.repo);
  if (input.branch) params.set('branch', input.branch);

  const result = await fetch(`/_api/github/tree?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
